import z from 'zod';
import {
	BuildChartContext,
	ExtendedChartWidgetProps,
	updateChartTitleSchema,
} from '../types';
import { devDebug } from '@/utils/dev-debug';

type UpdateChartTitleHelperParams = {
	chartTitle: string;
	chartWidgetProps: ExtendedChartWidgetProps;
};

export const updateChartTitleHelper = ({
	chartTitle,
	chartWidgetProps,
}: UpdateChartTitleHelperParams): ExtendedChartWidgetProps => {
	return {
		...chartWidgetProps,
		title: chartTitle,
	};
};

export const updateChartTitle = async (
	{ chartId, chartTitle }: z.infer<typeof updateChartTitleSchema>,
	context: BuildChartContext,
) => {
	devDebug('toolCall', {
		tool: 'updateChartTitle',
		chartId,
		chartTitle,
	});

	const chartWidgetProps = context.retrieveChart?.(chartId);
	if (!chartWidgetProps) {
		throw new Error(`Chart not found`);
	}

	const updatedChartWidgetProps = updateChartTitleHelper({
		chartTitle,
		chartWidgetProps,
	});

	context.saveChart?.(chartId, updatedChartWidgetProps);

	return {
		message: 'Chart title updated successfully',
	};
};
